export default "__VITE_ASSET__B1mY5bMB__";